module.exports = __webpack_public_path__ + "static/media/economicStatistics.2fd45485.svg";